// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSocialYoutube = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.562 18.732c-1.07-.009-2.137-.017-3.185-.235-1.947-.398-2.116-2.322-2.261-3.968l-.008-.086a28.44 28.44 0 0 1 .258-7.045c.216-1.302 1.064-2.08 2.377-2.164 4.43-.307 8.888-.27 13.308-.127.467.013.937.085 1.397.166 2.163.38 2.317 2.437 2.454 4.267l.021.274a25.747 25.747 0 0 1-.196 5.735c-.225 1.573-.656 2.893-2.475 3.02-2.278.166-4.504.3-6.79.258 0-.01-.012-.01-.019-.01l-4.103-.075c-.26-.006-.519-.008-.778-.01zM15.14 11.9l-2.756-1.584-2.352-1.351v5.87l2.13-1.225c.992-.57 1.981-1.139 2.978-1.71z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSocialYoutube;
